import { Role } from '@/Enums/Users/Role.enum';
import { isSuperAdminRole } from '@/helpers/roles';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import AccountType from './Components/AccountType';
import Advertiser from './Components/Advertiser';
import Clients from './Components/Clients';
import User from './Components/User';
import UserActions from './Components/UserActions';

export const getColumns = (
  handleEnterImpersonationMode: (id: number) => void,
  handleViewProfileClick: (id: number) => void,
  removeUser: (id: number) => void,
  meId: number,
  meRole: Role,
) =>
  [
    {
      field: 'fullName',
      headerName: 'Full Name',
      display: 'flex',
      renderCell: ({ row }: GridRenderCellParams) => (
        <User firstName={row.firstName} lastName={row.lastName} email={row.email} />
      ),
      flex: 1.5,
    },
    {
      field: 'role',
      headerName: 'Account Type',
      display: 'flex',
      renderCell: ({ value }: GridRenderCellParams) => <AccountType userRole={value} />,
      maxWidth: 180,
    },
    {
      field: 'clients',
      headerName: 'Client',
      sortable: false,
      display: 'flex',
      renderCell: ({ value, row }: GridRenderCellParams) => <Clients userRole={row.role} clients={value} />,
      flex: 2,
    },
    {
      field: 'advertiser',
      headerName: 'Advertiser',
      sortable: false,
      display: 'flex',
      renderCell: ({ value, row }: GridRenderCellParams) => <Advertiser userRole={row.role} advertiser={value} />,
    },
    {
      field: 'action',
      headerName: 'Action',
      headerAlign: 'center',
      sortable: false,
      display: 'flex',
      renderCell: ({ row }: GridRenderCellParams) => (
        <UserActions
          onImpersonationClick={() => handleEnterImpersonationMode(row.id)}
          onViewProfileClick={() => handleViewProfileClick(row.id)}
          onRemoveClick={() => removeUser(row.id)}
          disabled={row.id == meId}
          editSelfEnabled={isSuperAdminRole(meRole)}
        />
      ),
      maxWidth: 245,
    },
  ].map(item => ({
    ...item,
    flex: item.flex ?? 1,
  }));
